// extracted by mini-css-extract-plugin
export default {"wrapper":"Tga","container":"Uga","title":"Vga","carousel":"Wga","review":"Xga","name":"Yga","rating":"Zga","heading":"aha","body":"bha"};
    if(module.hot) {
      // 1726593108546
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  